import React, { useState } from 'react'
import './index.scss'
import useI18n from '../../i18n/useI18n'

const Table = ({
  columns = [],
  data = [],
  loading = false,
  emptyMessage = "Veri bulunamadı",
  renderActions = null, // Function to render action buttons: (row) => JSX
  onRefresh = null, // Function to refresh table data: () => void
  onSort = null, // Function to handle sort: (columnKey, direction) => void
  showAutoId = true, // Otomatik ID sütunu göster
  pagination = null // Pagination bilgisi (page, limit) - ID numaralandırması için
}) => {
  const [sortColumn, setSortColumn] = useState(null)
  const [sortDirection, setSortDirection] = useState(null)
  const { t } = useI18n()
  // ID'nin formatlanmış olup olmadığını kontrol et (harf, tire, özel karakter içeriyorsa formatlanmıştır)
  const isFormattedId = (id) => {
    if (id === null || id === undefined || id === '') return false
    const idString = String(id)
    // Sadece rakamlardan oluşuyorsa formatlanmamıştır
    return !/^\d+$/.test(idString)
  }

  // ID değerini hesapla - formatlanmışsa sıra numarası, değilse gerçek ID
  const getDisplayId = (row, index) => {
    if (!showAutoId) return null

    const rowId = row.id || row._id || row.ID
    if (isFormattedId(rowId)) {
      // Formatlanmış ID ise sıra numarası kullan
      const page = pagination?.page || 1
      const limit = pagination?.limit || data.length || 10
      return (page - 1) * limit + index + 1
    }
    // Formatlanmamış ID ise gerçek ID'yi kullan
    return rowId !== undefined && rowId !== null ? rowId : index + 1
  }

  const handleSort = (column) => {
    if (!onSort) return

    // String column'lar sortable olamaz
    if (typeof column === 'string') return

    // sortable false ise sort yapma
    if (column.sortable === false) return

    const columnKey = column.key

    let newDirection = 'ASC'
    if (sortColumn === columnKey && sortDirection === 'ASC') {
      newDirection = 'DESC'
    } else if (sortColumn === columnKey && sortDirection === 'DESC') {
      // Reset sort
      setSortColumn(null)
      setSortDirection(null)
      onSort(columnKey, null)
      return
    }

    setSortColumn(columnKey)
    setSortDirection(newDirection)
    onSort(columnKey, newDirection)
  }

  const renderSortIcon = (column) => {
    if (!onSort) return null

    // String column'lar sortable olamaz
    if (typeof column === 'string') return null

    // sortable false ise icon gösterme
    if (column.sortable === false) return null

    const columnKey = column.key

    if (sortColumn !== columnKey) {
      return <i className="zmdi zmdi-sort sort-icon sort-icon-inactive"></i>
    }

    if (sortDirection === 'ASC') {
      return <i className="zmdi zmdi-sort-asc sort-icon sort-icon-active"></i>
    } else if (sortDirection === 'DESC') {
      return <i className="zmdi zmdi-sort-desc sort-icon sort-icon-active"></i>
    }

    return <i className="zmdi zmdi-sort sort-icon sort-icon-inactive"></i>
  }
  const renderContent = () => {
    const hasData = data && data.length > 0

    return (
      <div className="table-responsive">
        {loading && hasData && (
          <div className="table-loading-overlay">
            <div className="table-loading-spinner">
              <i className="zmdi zmdi-refresh zmdi-hc-spin"></i>
            </div>
          </div>
        )}
        {!hasData && !loading && (
          <div className="text-center p-4">
            <p>{emptyMessage}</p>
          </div>
        )}
        {(hasData || loading) && (
          <table className="table table-hover mb-0 c_table_v1">
            <thead>
              <tr>
                {showAutoId && <th>ID</th>}
                {columns.map((column, index) => {
                  const columnKey = typeof column === 'string' ? column : column.key
                  const isSortable = onSort && typeof column === 'object' && column.sortable !== false

                  return (
                    <th
                      key={index}
                      className={isSortable ? 'sortable-header' : ''}
                      onClick={() => isSortable && !loading && handleSort(column)}
                      style={{ cursor: isSortable && !loading ? 'pointer' : 'default' }}
                    >
                      <span className="header-content">
                        {column.label || column}
                        {renderSortIcon(column)}
                      </span>
                    </th>
                  )
                })}
                {renderActions && <th>{t('QUOTA_COLUMNS_ACTIONS')}</th>}
              </tr>
            </thead>
            <tbody>
              {loading && !hasData ? (
                <tr>
                  <td colSpan={columns.length + (showAutoId ? 1 : 0) + (renderActions ? 1 : 0)} className="text-center p-4">
                    <p>{t('COMMON_LOADING')}</p>
                  </td>
                </tr>
              ) : (
                data.map((row, rowIndex) => (
                  <tr key={rowIndex} className={loading ? 'table-row-loading' : ''}>
                    {showAutoId && (
                      <td>
                        {getDisplayId(row, rowIndex)}
                      </td>
                    )}
                    {columns.map((column, colIndex) => {
                      const columnKey = typeof column === 'string' ? column : column.key;
                      const cellValue = column.render
                        ? column.render(row[columnKey], row)
                        : row[columnKey];

                      return (
                        <td key={colIndex}>
                          {cellValue}
                        </td>
                      );
                    })}
                    {renderActions && (
                      <td>
                        {renderActions(row)}
                      </td>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    )
  }

  return (
    <div className="card">
      <div className="body">
        {renderContent()}
      </div>
    </div>
  )
}

export default Table

